import { render, staticRenderFns } from "./Component-13.vue?vue&type=template&id=f552c43a&scoped=true&"
import script from "./Component-13.vue?vue&type=script&lang=js&"
export * from "./Component-13.vue?vue&type=script&lang=js&"
import style0 from "./Component-13.vue?vue&type=style&index=0&id=f552c43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f552c43a",
  null
  
)

export default component.exports